import { render } from "./AddEvaluation.vue?vue&type=template&id=756f959e"
import script from "./AddEvaluation.vue?vue&type=script&lang=js"
export * from "./AddEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__